// extracted by mini-css-extract-plugin
export default {"root":"Dropdown_root__WT-1p","input":"Dropdown_input__ZhsLc","dropdown":"Dropdown_dropdown__6ka+G","option":"Dropdown_option__TtlZu"};